<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Usuários</h1>
        <paragrafo
          >Inclusão e edição de usuários que terão acesso ao ambiente
          Admin.</paragrafo
        >
        <imagem :src="image_3" />
        <paragrafo>Preencha todas as informações e salve:</paragrafo>
        <li>Nome;</li>
        <li>E-mail (será utilizado no login);</li>
        <li>Senha (será utilizado no login);</li>
        <li>Status: Ativo ou Inativo.</li>
        <imagem :src="image_4" />
        <paragrafo
          >Será enviado ao usuário um e-mail com informações de
          login.</paragrafo
        >
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "Usuarios",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    // negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_3: "/imagensAdmin/Pessoas/pessoas3.png",
      image_4: "/imagensAdmin/Pessoas/pessoas4.png",
    };
  },
};
</script>
